const APP_PRIVACY_URL = 'https://www.protokol.com/privacy-policy/';

export { APP_PRIVACY_URL };
